import { Component, OnInit, ViewContainerRef, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { HttpClientCustom } from '../shared/services/http.client';
import { Configuration } from '../shared/services/configuration';
import { SharedData } from '../shared/sharedData';
import * as FileSaver from 'file-saver';
import { Headers } from '@angular/http/src/headers';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cob',
  templateUrl: './cob.component.html'
})
export class CobComponent {

  public uploadFileConfirm: any;
  public localState: any;
  public uploadDoc: any = false;
  public allData: any = [];
  public allPageData: any = [];
  public pageSize: any = 10;
  public page = 1;
  public startingPage: any = 1;
  public endingPage: any = 10;
  public collectionSize: any;
  public showGrid: any = false;
  public attachmentFile: any;
  public fileNameToUpload: any = null;
  public fileType: any = false;
  public uploadButtonDisable: any = false;
  public trackHides: any = null;
  public comments: any = '';
  public _baseUrl: any;
  public fileExtension: any;

  constructor(
    public route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public _location: Location,
    public _toast: ToasterComponent,
    public viewContainerRef: ViewContainerRef,
    public _http: HttpClientCustom,
    public eRef: ElementRef,
    public _global: Configuration,
    public translate: TranslateService,
    public _share: SharedData) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    _toast.setViewRef(viewContainerRef);
    this.getAll();
  }

  public goToBackPage() {
    this._location.back();
  }
  public handleChange($event) {
    this.uploadDoc = true;
  }

  public downloadTemplate() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/cob/downloadTemplate/type/ALL'
        + '/isOlderExcelFormat/' + this.fileType;
      this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
        let name = this.getFileNameFromHeader(result.headers);
        FileSaver.saveAs(result.body, name);
      });
    } catch (e) {
      console.log('download error caught', e);
    }
  }

  public getFileNameFromHeader(headers: HttpHeaders): string {
    let header = headers.get('Content-Disposition');
    if (header == null) {
      return 'CobUploadTemplate.xlxs';
    } else {
      if (!header) {
        return null;
      }
      let result: string = header.split(';')[1].trim().split('=')[1];
      return result.replace(/'/g, '');
    }
  }
  public OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getAll();
  }

  public onPageChange(event: number): void {
    if (event === 1) {
      this.startingPage = 1;
      this.endingPage = 10;
    } else {
      this.startingPage = 1 + this.pageSize;
      if (this.collectionSize > this.endingPage) {
        this.endingPage = event + this.endingPage;
      } else {
        this.endingPage = this.collectionSize;
      }
    }
    this.page = event;
    this.getAll();
  }

  public chooseFile(event) {
    if (event.target.files && event.target.files.length > 0) {
      let self = this;
      self.attachmentFile = event.target.files[0];
      self.fileNameToUpload = event.target.files[0].name;
      event.srcElement.value = null;
    }
  }

  public validate() {
    if (this.comments.trim() === '') {
      this.translate.get('commentsMandatory').subscribe((msg) => {
        this._toast.showError(msg);
      });
      return false;
    } else {
      return true;
    }
  }

  public processCob() {
    if (this.validate()) {
      const self = this;
      self.uploadButtonDisable = true;
      let formData: FormData = new FormData();
      formData.append('file', self.attachmentFile);
      formData.append('comment', self.comments);
      let url = self._baseUrl + 'v1/webAdmin/cob/process';
      self._http.filePost(url, formData).subscribe((res) => {
        this.translate.get('fileUpdatedSuccessfully').subscribe((msg) => {
          this._toast.showSuccess(msg);
        });
        self.getAll();
        self.fileNameToUpload = null;
        self.comments = '';
        self.uploadButtonDisable = false;
      }, (error) => {
        self.handelUploadError(error);
      });
    }
  }

  public handelUploadError(error) {
    if (error.status === 409) {
      this.translate.get('canNotUploadCob').subscribe((msg) => {
        this._toast.showError(msg);
      });

    } else {
      this.translate.get('fileUploadFailed').subscribe((msg) => {
        this._toast.showError(msg);
      });
    }
    this.getAll();
    this.fileNameToUpload = null;
    this.comments = '';
    this.uploadButtonDisable = false;
  }

  public uploadConfirm(processId) {
    const self = this;
    self.uploadButtonDisable = true;
    let url = this._baseUrl + 'v1/webAdmin/cob/upload?processId=' + processId;
    self._http.post(url, processId).subscribe((result) => {
      self.uploadFileConfirm = result;
      self.translate.get('fileUploaded').subscribe((msg) => {
        self._toast.showSuccess(msg);
      });
      self.getAll();
      self.uploadButtonDisable = false;
    }, (error) => {
      self.handelUploadError(error);
    });
  }

  public conTanActions(value) {
    if (this.trackHides === value) {
      this.trackHides = null;
    } else {
      this.trackHides = value;
    }
  }

  @HostListener('window:click', ['$event'])
  public clickOut(event) {
      if (!this.eRef.nativeElement.contains(event.target)) {
          setTimeout(() => {
              this.trackHides = null;
          }, 10);
      }
  }

  public clicked() {
    this.trackHides = null;
}

  public cancelProcess(processId) {
    const self = this;
    self.uploadButtonDisable = true;
    let url = this._baseUrl + 'v1/webAdmin/cob/cancelProcess?processId='
      + processId + '&reason=Force closed';
    self._http.post(url, processId).subscribe((result) => {
      self.uploadFileConfirm = result;
      self.translate.get('cancelFileUpload').subscribe((msg) => {
        self._toast.showSuccess(msg);
      });
      self.getAll();
      self.uploadButtonDisable = false;
    }, (error) => {
      self.handelUploadError(error);
    });
  }

  public getAll() {
    let self = this;
    self.uploadButtonDisable = true;
    let url = self._baseUrl + 'v1/webAdmin/uploadProcess/getAllByGroup?group=HRIS'
      + '&page=' + self.page + '&pageSize=' + self.pageSize;
    self._http.get(url).subscribe((result) => {
      self.allData = result.content;
      self.allPageData = result;
      self.collectionSize = result.totalElements;
      if (self.collectionSize < self.pageSize) {
        self.endingPage = self.collectionSize;
      }
      self.showGrid = true;
      this.uploadButtonDisable = false;
    }, (error) => {
      console.log(error);
    });
  }
  public getExtension(fileName) {
    this.fileExtension = fileName.split('.').pop();
    return this.fileExtension.toLowerCase();
  }

  public getDateFormat(date) {
    let dateCreated = new Date(date);
    return dateCreated.toString().substring(4, 15);
  }

  public downloadValidationFile(path) {
    let self = this;
    let url = self._baseUrl + 'v1/webAdmin/uploadProcess/downloadFile/' + path;
    this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
      let name = this.getFileNameFromHeader(result.headers);
      FileSaver.saveAs(result.body, name);
    }, (error) => {
      console.log(error);
    });
  }

  public clearSelection() {
    this.showGrid = false;
  }
  public onFileTypeChange(event) {
    if (event === 'xlsx' || event === 'XLSX') {
      this.fileType = false;
    } else {
      this.fileType = true;
    }
  }

  public onRefresh(){
    this.getAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/cob/cob.component.ts